export default {
  Switch: {
    orderBy: 'executionOrder asc',
    searchSelect: ['actionSwitchCaseNextActionName', 'evaluationObservations'],
    notSelectSearch: 'groupsEvaluationResults',
    expand: {
      groupsEvaluationResults: {
        select:
          'logicalOperator,isSuccessfullyResult,evaluationObservations,parentActionConditionGroupEvaluationResultId',
        expand: {
          actionConditionEvaluationResults: { select: '*' },
        },
      },
    },
  },

  Iterate: {
    orderBy: 'executionOrder asc',
    searchSelect: ['itemDisplayText'],
    notSelectSearch: 'iterationActionInstances',
  },

  Conditional: {
    expand: {
      groupsEvaluationResults: {
        select:
          'logicalOperator,isSuccessfullyResult,evaluationObservations,parentActionConditionGroupEvaluationResultId',
        expand: {
          actionConditionEvaluationResults: { select: '*' },
        },
      },
    },
  },
  ConsumeSequence: {
    select: 'id,sequencePattern,sequenceItemPattern,generatedNumber,sequenceItemId,sequenceTraceId',
    orderBy: 'created desc',
  },
};
